module.exports = __webpack_public_path__ + "img/1-4.1153f287.png";